import React, { useContext } from "react";
import { Carousel, Col, Container, Image, Navbar, Row } from "react-bootstrap";
import AppContext from "../context/AppContext";

const Trainings = () => {
  const { sliderImages } = useContext(AppContext);
  return (
    <>
      <Container fluid>
        <Row>
          <Navbar
            variant="dark"
            style={{ height: "15vh" }}
            className="d-flex justify-content-center align-items-center"
          >
            <h1>Navbar</h1>
          </Navbar>
        </Row>
        <Row>
          <Col>
            <Carousel>
              {sliderImages.map((item) => {
                return (
                  <Carousel.Item>
                    <Image fluid src={item.src} style={{height:'85vh', width : '100%'}}></Image>
                    <Carousel.Caption>
                      <h3>{item.alt}l</h3>
                      <p>
                        Nulla vitae elit libero, a pharetra augue mollis
                        interdum.
                      </p>
                    </Carousel.Caption>
                  </Carousel.Item>
                );
              })}
            </Carousel>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Trainings;
